import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoColaboradoresIDSEExportarConfirmarComponent {
  proyectoId
  colaboradores
  tipoMovimientoId
  onClose
  descargando = false
  error = null
  idse_id = null

  constructor (FanProyectoColaboradoresIDSEOperadoraService, FanProyectoColaboradoresIDSEMovimientosService, FanProyectoColaboradoresIDSEArchivoService) {
    this.FanProyectoColaboradoresIDSEOperadoraService = FanProyectoColaboradoresIDSEOperadoraService
    this.FanProyectoColaboradoresIDSEMovimientosService = FanProyectoColaboradoresIDSEMovimientosService
    this.FanProyectoColaboradoresIDSEArchivoService = FanProyectoColaboradoresIDSEArchivoService
  }

  $onInit () {
    this.FanProyectoColaboradoresIDSEOperadoraService.get(this.proyectoId)
      .then(({data}) => {
        this.operadora = data
        if (!this.operadora) {
          this.error = 'El proyecto no tiene asignada una operadora'
        }
      })
  }

  generar () {
    if (this.generando) return

    this.generando = true
    this.error = null
    let data = {colaboradores: this.colaboradores.map((item) => item.id)}

    this.FanProyectoColaboradoresIDSEMovimientosService.post(this.proyectoId, this.tipoMovimientoId, data)
      .then((response) => {
        this.generado = true
        this.idse_id = response.data.idse_id
      })
      .catch((error) => (this.error = error.data))
      .finally(() => (this.generando = false))
  }

  descargar () {
    if (this.descargando) return

    this.descargando = true
    this.error = null

    this.FanProyectoColaboradoresIDSEArchivoService.get(this.proyectoId, this.idse_id, this.tipoMovimientoId)
      .then(({data}) => (data.save()))
      .catch((error) => (this.error = error.data))
      .finally(() => (this.descargando = false))
  }

  cerrar () {
    this.onClose({$event: {detail: {generado: this.generado}}})
  }
}

module.component('fanProyectoColaboradoresIdseExportarConfirmar', {
  controller: FanProyectoColaboradoresIDSEExportarConfirmarComponent,
  template,
  bindings: {
    proyectoId: '<',
    tipoMovimientoId: '<',
    colaboradores: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/colaboradores/idse/exportar/confirmar/component.js